/*

Adityaa 09/29/2022 2699250881 Minor Changes
Ashraf 10/06/2022 2699250881 added comments to code, removed unusual code
Ashraf 10/15/2022 2699250881 Added custom windows code comments

*/

import React from 'react';
import Fields from './Fields';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';

// fields table, form component render (2699250881)

export default function FormBuilder({
  UDWData,
  formData,
  setFormData,
  windowNumber,
  udwView,
  editable,
  setEditable,
  isCopyRowData,
  setDeleted,
  setDeletedFields,
  deletedFields,
  editExisting,
  reset,
  deleted,
  initialValues,
  setEditExisting,
  changedWindowNumber,
  dirty,
}) {
  return (
    <div>
      <ErrorBoundaryForComponents>
        <Fields
          udwView={udwView}
          formData={formData}
          setFormData={setFormData}
          editable={editable}
          setEditable={setEditable}
          UDWData={UDWData}
          reset={reset}
          deleted={deleted}
          setDeleted={setDeleted}
          initialValues={initialValues}
          editExisting={editExisting}
          windowNumber={windowNumber}
          isCopyRowData={isCopyRowData}
          setDeletedFields={setDeletedFields}
          deletedFields={deletedFields}
          changedWindowNumber={changedWindowNumber}
          setEditExisting={setEditExisting}
          dirty={dirty}
        />
      </ErrorBoundaryForComponents>
    </div>
  );
}
